import React, { useState } from "react";
import {
  Card,
  Button,
  Input,
  Typography,
  Notification,
  Switch,
} from "@mex/mex-web-ui";
import { Modal } from "@duxton-web/ui";
import "./feature-flag-manager.less";
import { IconSearch } from "@mex/mex-web-ui/lib/icons";

export const FeatureFlagManager = ({ visible, onCancel }) => {
  const [features, setFeatures] = useState(() => {
    const storedFeatures = JSON.parse(
      localStorage.getItem("featureFlags") || "{}"
    );
    return storedFeatures;
  });

  const [jsonInputs, setJsonInputs] = useState({});
  const [searchInput, setSearchInput] = useState("");

  const handleChange = (key, value) => {
    setFeatures({ ...features, [key]: value });
  };

  const handleSave = () => {
    let newFeatures = { ...features };

    for (let key in jsonInputs) {
      try {
        newFeatures[key] = JSON.parse(jsonInputs[key]);
      } catch (e) {
        Notification.error({
          title: `Invalid JSON Input for ${key}`,
          placement: "topRight",
        });
        return;
      }
    }

    localStorage.setItem("featureFlags", JSON.stringify(newFeatures));
    Notification.success({
      title: "Feature Flags Updated",
      placement: "topRight",
    });
    onCancel();
  };

  //Search feature flags
  const filteredFeatureFlags = (searchInput) => {
    if (searchInput === "") return Object.keys(features);
    const filteredFeatures = Object.keys(features).filter((key) => {
      return key.toLowerCase().includes(searchInput.toLowerCase());
    });
    return filteredFeatures;
  };

  return (
    <div className="feature-flag-manager-container">
      <Modal
        className="feature-flag-manager"
        open={visible}
        onCancel={onCancel}
        footer={null}
        destroyOnClose
      >
        <div className="flag-container">
          <Typography variant="heading02">Feature Flags</Typography>
          <Typography variant="body02Regular">
            Turn feature flags on/off for your local machine, only available on
            staging and development
          </Typography>
          <Input
            name="search"
            onChange={(e) => setSearchInput(e.target.value)}
            placeholder="Search for feature flags here"
            className="search-input"
            leftIcon={<IconSearch />}
            autoComplete="off"
          />
          {filteredFeatureFlags(searchInput).map((key) => (
            <div className="flag-body" key={key}>
              {typeof features[key] === "boolean" ? (
                <Card className="flag-card">
                  <Switch
                    onChange={(e) => handleChange(key, e.target.checked)}
                    label={key}
                    checked={features[key]}
                    labelPlacement="left"
                  />
                </Card>
              ) : (
                <Card className="flag-card">
                  <Input
                    label={key}
                    type="textarea"
                    value={
                      jsonInputs[key] || JSON.stringify(features[key], null, 2)
                    }
                    onChange={(e) =>
                      setJsonInputs((prevJsonInputs) => ({
                        ...prevJsonInputs,
                        [key]: e.target.value,
                      }))
                    }
                    autoComplete="off"
                  />
                </Card>
              )}
            </div>
          ))}
        </div>
        <div>
          <Button className={"save-cta"} onClick={handleSave}>
            Save Changes
          </Button>
        </div>
      </Modal>
    </div>
  );
};
